module.exports = "::ng-deep .slider-locales-switcher mat-option .mat-option-text {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center; }\n  ::ng-deep .slider-locales-switcher mat-option .mat-option-text img {\n    height: 1.3rem;\n    margin-right: 0.5rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms-brand/src/home-slider/home-slider-form/home-slider-form.component.scss
// module id = ./libs/atenea-cms-brand/src/home-slider/home-slider-form/home-slider-form.component.scss
// module chunks = main